import SimpleSelect from '@components/V3/forms/SimpleSelect'
import Text from '@components/V3/forms/Text'

import {ReservationLabel} from '../Label'
import {useCreateReservationContext} from '../ReservationContext'

export default function OtherData() {
  const {specialRequests, setSpecialRequests, specialOccasion, setSpecialOccasion, storeOptions} =
    useCreateReservationContext()

  return (
    <div className="">
      <ReservationLabel className="mb-3">
        ¿Quieres agregar mas detalles? (opcional)
      </ReservationLabel>
      <SimpleSelect
        placeholder="¿Es una ocasión especial?"
        value={specialOccasion}
        onChange={setSpecialOccasion}
        options={storeOptions.specialOccasionOptions}
        isClearable
      />
      <Text
        placeholder="¿Tienes algun requerimiento especial?"
        value={specialRequests}
        onChange={setSpecialRequests}
      />
    </div>
  )
}
